import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=520f5188&scoped=true&"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js&"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=520f5188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f5188",
  null
  
)

export default component.exports